<div class="popup-backdrop" *ngIf="isOpen" (click)="closePopup()">
  <div class="popup-container" *ngIf="divVisible && contentLoaded" (click)="preventBackdropClick($event)">
    <div class="popup-conta" [@slideUp]="animationState" (@slideUp.done)="onAnimationDone($event)">
      <div class="row-header">
        <div class="drag-handle" (mousedown)="onDragStart($event)" (touchstart)="onDragStart($event)"></div>
        <div #nameLine class="nameLine" [style.display]="nameLineDisplay">
          <h1 class="dish-title">{{ dish?.Name || ingredientName }} </h1>
          <div class="divider"></div>
        </div>
        <button class="close-button" (click)="closePopup()"></button>
      </div>

      <div class="popup-overlay" #popupOverlay (click)="closeInfo($event)" (scroll)="onScroll($event)" id="popup-overlay">
        <div id='image2' class="background-image" [@fadeImage]="imageVisible ? 'visible' : 'hidden'"
          [style.backgroundImage]="'url(' + setsList.BigImageFile + ')'">
        </div>

        <div class="content">
          <h1 class="dish-title">{{ dish?.Name || ingredientName }}</h1>
          <p class="dish-description">{{ setsList.Description }}</p>
          <p class="dish-price">{{ myDesignPrice }}</p>
          <div class="divider"></div>

          <!-- Recursive Ingredient Template -->
          <ng-template #recursiveIngredients let-ingredient="ingredient" let-parentSet="parentSet" let-level="level">
              <div 
    class="ingredient-item" 
    [class.hidden]="ingredient.isHidden === 1"
  [ngClass]="{
    'selected-highlight': ingredient.SelectedCount > 0,
    'ingredient-pressed': ingredient.isPressed
  }"
    (click)="ingredient.isHidden !== 1 && toggleIngredient(ingredient, parentSet)"
    style="cursor: pointer; border-radius: 8px; transition: background 0.2s;"
  >
              <div class="IngeduantLine" [ngStyle]="{'padding-left': (level * 16) + 'px'}">
                <!-- Checkbox -->
                <span
                  [id]="'ing-level-' + level + '-' + ingredient.ID"
                  class="checkBox"
                  [ngClass]="{'checked': ingredient.SelectedCount > 0}"
                  [ngStyle]="{
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }"
                >
                  <!-- Checked: green box with checkmark -->
                  <ng-container *ngIf="ingredient.SelectedCount > 0; else notChosen">
                    <svg 
                      [attr.width]="iconSize" 
                      [attr.height]="iconSize" 
                      [attr.viewBox]="'0 0 ' + iconSize + ' ' + iconSize" 
                      fill="none" 
                      xmlns="http://www.w3.org/2000/svg">
                      <circle 
                        [attr.cx]="iconSize/2" 
                        [attr.cy]="iconSize/2" 
                        [attr.r]="iconSize/2 - iconSize*0.09" 
                        fill="#29BF65" 
                        stroke="#29BF65" 
                        [attr.stroke-width]="iconSize * 0.09"/>
                      <path
                        [attr.d]="checkmarkPathD"
                        stroke="white"
                        [attr.stroke-width]="3"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </ng-container>
                  <!-- Not chosen: green circle outline -->
                  <ng-template #notChosen>
                    <svg 
                      [attr.width]="iconSize" 
                      [attr.height]="iconSize" 
                      [attr.viewBox]="'0 0 ' + iconSize + ' ' + iconSize" 
                      fill="none" 
                      xmlns="http://www.w3.org/2000/svg">
                      <circle 
                        [attr.cx]="iconSize/2" 
                        [attr.cy]="iconSize/2" 
                        [attr.r]="iconSize/2 - iconSize*0.09" 
                        [attr.stroke]="ingredient.isHidden !== 1 ? '#29BF65' : '#D9D9D9'"
                        [attr.fill]="ingredient.isHidden !== 1 ? 'none' : '#F2F2F2'"
                        [attr.stroke-width]="iconSize * 0.06"/>
                    </svg>
                  </ng-template>
                </span>
                
                <!-- Ingredient Name and Price -->
                <label
                  [for]="'ing-level-' + level + '-' + ingredient.ID"

                  class="ingrediantLable"
                  [ngClass]="{'ingredient-disabled': ingredient.isHidden === 1}"
                  [ngStyle]="parentSet.IsMultiple === 1 ? {'max-width': '200px'} : {'max-width': '80vw'}"
                >
                  {{ ingredient.IngredientName }}
               
                   <span *ngIf="parentSet.IsFreeShow == true && (ingredient.Price > 0 || (ingredient.SelectedCount > 0 && ingredient.DealOrderMenu?.IngredientsPrice > 0))"
                    class="ingrediantLable"
                  [ngClass]="{'ingredient-disabled': ingredient.isHidden === 1}">
                (+₪{{ 
    (+ingredient.Price) + 
    (ingredient.SelectedCount > 0 ? (+ingredient.DealOrderMenu?.IngredientsPrice || 0) : 0) 
  }})
            </span>
                 <div *ngIf="ingredient.SelectedCount > 0 && ingredient.DealOrderMenu">
              <div class="invite-flex-row">
                <span *ngIf="ingredient.DealOrderMenu.InviteName">{{ ingredient.DealOrderMenu.InviteName }} | </span>
                <span *ngIf="ingredient.DealOrderMenu.Comments">{{ ingredient.DealOrderMenu.Comments }} | </span>
                <span *ngIf="ingredient.DealOrderMenu.listSets && ingredient.DealOrderMenu.listSets.length > 0" >
                  {{ getAllIngredientNames(ingredient.DealOrderMenu.listSets).join(', ') }}
                </span>
                </div>
            </div>
                </label>

                <!-- Info Button -->
                <div [id]="'spaceElement' + parentSet.ID + ingredient.ID" class="infoSide">
                  <div *ngIf="ingredient.Info" class="IngeduantLine">
                    <div class="infoButton-container">
                      <button class="infoButton" 
                              (click)="showInfo(ingredient , parentSet.ID) ; $event.stopPropagation()"
                              name="infoButton"
                              type="button">
                      </button>
                      <div style="display: none"
                        [id]="'infoSideDiv'+ parentSet.ID + ingredient.ID"
                        class="info-balloon"
                        [class.inline]="hasInlineSpace"
                        [class.below]="!hasInlineSpace">
                        {{ ingredient.Info }}
                      </div>
                      <div 
                        [id]="'infoSideForDesign'+ parentSet.ID + ingredient.ID"
                        class="info-balloon-for-design">
                        {{ ingredient.Info }}
                      </div>
                    </div>
                    <div class="infoSide"></div>
                  </div>
                </div>

                <!-- Quantity Controls -->
                <div *ngIf="parentSet.IsMultiple === 1" class="quantity-controls">
                  <button (click)="decreaseQuantity(ingredient, parentSet, true); $event.stopPropagation()"
                        class="ButtonMinus"
                        [disabled]="ingredient.SelectedCount == 0">
                  </button>
                  <span class="countNumber">{{ ingredient.SelectedCount }}</span>  
                  <button (click)="increaseQuantity(ingredient, parentSet); $event.stopPropagation()"
                        class="ButtonPlus"
                        [disabled]="ingredient.SelectedCount >= parentSet.MaxCount">
                  </button>
                </div>
                <div *ngIf="ingredient.SelectedCount > 0 && ingredient.DealOrderMenu" class="quantity-controls">
                 
                  <button (click)="openNestedPopup(ingredient, parentSet); $event.stopPropagation()"
                        class="ButtonEdit"
                        [disabled]="ingredient.SelectedCount == 0">
                  </button>
                </div>
              </div>
          
            </div>
          </ng-template>

          <!-- Main Content -->
          <div class="list-container">
            <ng-container *ngFor="let set of setsList.list">
              <h1 class="setName" [id]="'startSet' + set.ID">{{ set.SetName }}</h1>
              <h2 class="requiredText"  [@shakeAnimation]="set.ChooseEnough" [ngStyle]=" set.ChooseEnough == 'ChooseEnough' ? set.isGreenFree ? {'color':'#29BF65'} :{'color':'#666469'} :{'color':'red'}  ">{{ set.TextForRequired }}</h2>
              
              <!-- Ingredients List -->
              <div class="ingredients-list">
                <ng-container *ngFor="let ingredient of set.Ingredients">
                  <ng-container *ngTemplateOutlet="recursiveIngredients; 
                    context: { 
                      ingredient: ingredient, 
                      parentSet: set,
                      level: 0 
                    }">
                  </ng-container>
                </ng-container>
              </div>

              <!-- Render nested sets after the set, not under the ingredient -->
              <ng-container *ngFor="let ingredient of set.Ingredients">
                <ng-container *ngIf="ingredient.internalSets?.length && ingredient.SelectedCount > 0 && !ingredient.internalSets[0].MenuID > 0 ">
                  <ng-container *ngFor="let internalSet of ingredient.internalSets">
                    <div class="nested-sets-container" [@nestedSetAnimation]>
                      <div class="divider" [id]="'startSet' + internalSet.ID"></div>
                      <h3 class="setName">{{ internalSet.SetName }}</h3>
                      <h2 class="requiredText" [@shakeAnimation]="internalSet.ChooseEnough"
                          [ngStyle]="internalSet.ChooseEnough == 'ChooseEnough' 
                            ? internalSet.isGreenFree ? {'color':'#29BF65'}
                            :{'color':'#666469'} 
                            :{'color':'red'}">
                        {{ internalSet.TextForRequired }}
                      </h2>
                      <div class="ingredients-list">
                        <ng-container *ngFor="let subIngredient of internalSet.Ingredients">
                          <ng-container *ngTemplateOutlet="recursiveIngredients; 
                            context: { 
                              ingredient: subIngredient, 
                              parentSet: internalSet,
                              level: 1 
                            }">
                          </ng-container>
                        </ng-container>
                      </div>
                      <!-- Recursively render nested sets after this set -->
                      <ng-container *ngFor="let subIngredient of internalSet.Ingredients">
                        <ng-container *ngIf="subIngredient.internalSets?.length && subIngredient.SelectedCount > 0 && !subIngredient.internalSets[0].MenuID > 0">
                          <ng-container *ngFor="let deeperSet of subIngredient.internalSets">
                            <div class="nested-sets-container" [@nestedSetAnimation]>
                              <div class="divider" [id]="'startSet' + deeperSet.ID"></div>
                              <h3 class="setName">{{ deeperSet.SetName }}</h3>
                              <h2 class="requiredText" [@shakeAnimation]="deeperSet.ChooseEnough"
                                  [ngStyle]="deeperSet.ChooseEnough == 'ChooseEnough' 
                                    ? deeperSet.isGreenFree ? {'color':'#29BF65'}
                                    :{'color':'#666469'} 
                                    :{'color':'red'}">
                                {{ deeperSet.TextForRequired }}
                              </h2>
                              <div class="ingredients-list">
                                <ng-container *ngFor="let subSubIngredient of deeperSet.Ingredients">
                                  <ng-container *ngTemplateOutlet="recursiveIngredients; 
                                    context: { 
                                      ingredient: subSubIngredient, 
                                      parentSet: deeperSet,
                                      level: 2 
                                    }">
                                  </ng-container>
                                </ng-container>
                              </div>
                              <!-- This pattern will repeat for deeper levels -->
                            </div>
                          </ng-container>
                        </ng-container>
                      </ng-container>
                    </div>
                  </ng-container>
                </ng-container>
              </ng-container>
              <div class="divider"></div>
            </ng-container>
          </div>

          <div class="boxUnder">
            <div class="DinersName">
              <p class="CommentsDishLable3" >שם הסועד</p>
              <input type="text" [(ngModel)]="setsList.DinerName" class="DinersNameInput" maxlength="25" />
            </div>
            <div class="CommentsDish" >
              <p class="CommentsDishLable2">הערות למנה</p>
              <p class="CommentsDishLable">בית העסק והשליח יכולים לראות את ההערה</p>
              <div style="position: relative;">
                <button class="delete-button" (click)="clearComments()"></button>
                <textarea (keyup)="autoGrowTextZone($event)" 
                  [(ngModel)]="setsList.Comments" 
                  class="CommentsDishInput">
                </textarea>
              </div>
              <div [ngStyle]="{'height': (safeAreaBottom + 50) + 'px'}" ></div>
            </div>
          </div>
        </div>
      </div>

      <div class="bottom-rectangles" [ngStyle]="{'bottom': (safeAreaBottom) + 'px'}" >
        <div class="first-rectangle {{ menuId != 0 ? 'first-rectangleDeal' : 'noFirst-rectangleDeal' }}">
          <div *ngIf="menuId==0" class="plusAndMinus">
            <button class="minusB" (click)="countDishClick(false)"></button>
            <span>{{ countDish }}</span>
            <button class="plusB" (click)="countDishClick(true)"></button>
          </div>
       <button 
  class="enterButton" 
  (click)="saveSetClick()" 
  [ngClass]="menuId != 0 ? 'enterButtonDeal' : ''"
>
  <span class="textEnterButton">הוספה להזמנה</span>
  <span class="textEnterButton">{{ totalPrice }}</span>
</button>
        </div>
        <div class="second-rectangle">
          <div class="third-rectangle"></div>
          <!-- Content for second rectangle -->
        </div>
      </div>
    </div>
  </div>

</div>
<app-popup-additionsSet
  *ngIf="nestedPopupOpen"
  class="nested"
  [isOpen]="nestedPopupOpen"
  [menuId]="nestedPopupParams?.menuId"
  [countNumber]="nestedPopupParams?.countNumber"
  [parentOrderListID]="nestedPopupParams?.parentOrderListID"
  [parentCountNumber]="nestedPopupParams?.parentCountNumber"
  [dishSetID]="nestedPopupParams?.dishSetID"
  [ingredientID]="nestedPopupParams?.ingredientID"
  [ingredientName]="nestedPopupParams?.ingredientName"
  [ingredientPrice]="nestedPopupParams?.ingredientPrice"
   [isFromEdit]="isChangeOnFood"
   [restaurantID]="dish?.restaurantID || restaurantID"
  (close)="onNestedClose()"
  (saveSet)="onNestedSaveSet()"
></app-popup-additionsSet>